import { jsx, jsxs } from "react/jsx-runtime";
import classNames from "classnames";
import { useState } from "react";
const form = "Form-module_form_1OnrS";
const heading = "Form-module_heading_BqFlu";
const description = "Form-module_description_bWuJc";
const submitButton = "Form-module_submitButton_mzvRA";
const inputsWrapper = "Form-module_inputsWrapper_sWeIj";
const styles$2 = {
  form,
  heading,
  description,
  submitButton,
  "submitButton--disabled": "Form-module_submitButton--disabled_28PKO",
  inputsWrapper
};
const text = "ValidationInputNotification-module_text_SiKrI";
const styles$1 = {
  text
};
const ValidationInputNotification = ({ className, text: text2 }) => {
  return /* @__PURE__ */ jsx("p", { className: classNames(styles$1.text, className), children: text2 });
};
const inputWrapper = "TextInput-module_inputWrapper_dHukP";
const label = "TextInput-module_label_zRNdf";
const input = "TextInput-module_input_oappV";
const styles = {
  inputWrapper,
  label,
  input,
  "input--invalid": "TextInput-module_input--invalid_9bJc0"
};
const Input = ({
  name,
  type,
  value,
  isRequired,
  onChange,
  touched,
  label: label2,
  placeholder,
  isValid
}) => {
  const renderAsterixOrNot = () => {
    return isRequired && /* @__PURE__ */ jsx("span", { "aria-hidden": true, children: "*" });
  };
  const isValidationFailed = isRequired && !value && touched && isValid === false;
  return /* @__PURE__ */ jsxs("div", { className: styles.inputWrapper, children: [
    /* @__PURE__ */ jsxs("label", { className: styles.label, children: [
      label2,
      renderAsterixOrNot(),
      /* @__PURE__ */ jsx(
        "input",
        {
          placeholder,
          className: classNames(styles.input, {
            [styles["input--invalid"]]: isValid === false
          }),
          type,
          name,
          value,
          onChange,
          "aria-required": isRequired,
          "aria-invalid": isValidationFailed
        }
      )
    ] }),
    isValidationFailed && /* @__PURE__ */ jsx(
      ValidationInputNotification,
      {
        className: styles.validation,
        text: "This field is required"
      }
    )
  ] });
};
const constructState = (fields) => {
  return fields.reduce(
    (acc, item) => {
      acc[item.name] = {
        value: "",
        isValid: item.isRequired ? void 0 : true,
        touched: false,
        isRequired: item.isRequired
      };
      return acc;
    },
    {}
  );
};
const getInputsValues = (data) => {
  return Object.keys(data).reduce(
    (acc, key) => {
      const value = data[key].value;
      acc[key] = value;
      return acc;
    },
    {}
  );
};
const getInputsValidity = (data) => {
  for (const key in data) {
    if (!data[key].isValid) {
      return false;
    }
  }
  return true;
};
const Form = ({ className, heading: heading2, description: description2, fields, onSubmit }) => {
  const [formState, setFormState] = useState(constructState(fields));
  const areInputsValid = getInputsValidity(formState);
  const handleInputChange = (fieldName) => (event) => {
    setFormState({
      ...formState,
      [fieldName]: {
        ...formState[fieldName],
        value: event.target.value,
        touched: true,
        isValid: formState[fieldName].isRequired ? !!event.target.value : true
      }
    });
  };
  const renderInputType = (inputData) => {
    switch (inputData.type) {
      case "text":
        return /* @__PURE__ */ jsx(
          Input,
          {
            id: inputData.name,
            type: inputData.type,
            name: inputData.name,
            value: formState[inputData.name].value,
            onChange: handleInputChange(inputData.name),
            isRequired: inputData.isRequired,
            touched: formState[inputData.name].touched,
            label: inputData.label,
            placeholder: inputData.placeholder,
            isValid: formState[inputData.name].isValid
          },
          inputData.name
        );
    }
  };
  const handleSubmit = (event) => {
    event.preventDefault();
    setFormState(formState);
    areInputsValid ? onSubmit(getInputsValues(formState)) : null;
  };
  return /* @__PURE__ */ jsxs("form", { className: classNames(styles$2.form, className), onSubmit: handleSubmit, children: [
    /* @__PURE__ */ jsx("h3", { className: styles$2.heading, children: heading2 }),
    /* @__PURE__ */ jsx("p", { className: styles$2.description, children: description2 }),
    /* @__PURE__ */ jsx("div", { className: styles$2.inputsWrapper, children: fields.map(renderInputType) }),
    /* @__PURE__ */ jsx(
      "button",
      {
        disabled: !areInputsValid,
        className: classNames(styles$2.submitButton, {
          [styles$2["submitButton--disabled"]]: !areInputsValid
        }),
        children: "Submit Form"
      }
    )
  ] });
};
export {
  Form as default
};
